export const assetType = {
  noTechnicalForm: "Aucun formulaire technique disponible pour ce type d'actif",
  infoSection: "Information du type d'actif",
  technicalForm: {
    title: "Formulaire technique",
    warning:
      "Les formulaires techniques doivent être configurés à partir de la nouvelle section <TemplateLink>Formulaires techniques</TemplateLink>.",
  },
  linkedAssets: "Nombre d'actifs liés",
  add: {
    label: "Ajouter un type d'actif",
  },
  delete: {
    label: "Supprimer le type d'actif",
  },
  create: {
    label: "Créer un type d'actif",
  },
  information: { label: "Information du type d'actif" },
  form: {
    edit: {
      label: "Modifier le type d'actif",
    },
    name: { label: "Nom" },
    category: {
      label: "Catégorie du type d'actif",
    },
    technicalForm: {
      label: "Formulaire technique",
      alert:
        'La mise à jour du champ "Formulaire technique" supprimera toutes les données techniques existantes de tous les actifs connexes.',
    },
  },
  deleteTooltipAssets:
    "Ce type d'actif ne peut pas être supprimé puisqu'il est lié à des actifs.",
};
